import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQD5ypWIMN7+UfaeYQX6zx3/kC8v\n' +
  'e3zKexj6gQkrS60VRv5LNjW2UgqIxvMYNa5GyuP6j5bhv4cTTWgCpu00NEbiqm1Y\n' +
  'tY62ZkOeEjMFgNF6zYp28Msl686yAC/7NSCLVzLHwETxtIxV9Sw/2oWx6Q4g6J8o\n' +
  'Tzj7vswaGZxJZboeUQIDAQAB'

const privateKey = 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBALGyBg4VbBKlePfB\n' +
  'DyfATu4m+RKTT1UbubxUDksj/kaeMQi07cgJVyXH8chHL1CB/QUqfVh3CY4pTh59\n' +
  '9OtA+zmcNMshMl7Eh4MRzv0s4beAd7MxS+qq+UyaOgJnoizT9A/QmIGUcpN6Qkqr\n' +
  'x35HzA3u+MphSiFgAfdJi7Ki9QZdAgMBAAECgYAENfTAxq8t7e/k5xVF2t/D8vZ6\n' +
  'AzWhDawkE1XXX/35jGwbCbaMw/PluEw5c75iSQJG6g/YVdHLJZ1tSYzROlP5qmG9\n' +
  's+qTX/0obiSpUDjzRg/p8oRjERzRjGv+fqWX7yI6Sc02VIP0XlxFdeywdvlL97UW\n' +
  '9klha4lLzGTEr9gX3QJBAOOcMwXY3ea7EGHn3K7xeUtbw2fsiAVuSPoRJSwHCvmW\n' +
  '16oub8nBkr6bpZTNhRguEaUw9dDzjDI8w43RaGegxQsCQQDH3AAtxBu5nD62UQuT\n' +
  'fUQjxRAwgjxSJtiP6mcZokoelQgC5AfyNOVROOOykBSa9/+/zFXnJ1JEPFPtvw6f\n' +
  'bLM3AkEAuZqsOL5p5Tbx2wS5/qbG5F7F778ABH20YMcOauKrXnBVGV+YpQuG4IwH\n' +
  '8FnPiLI4jV5pdaTE1EqcpM74tlhxlQJAXTaIhs/eNnVe8l1eTs2vyBcS8+zqAU7I\n' +
  '1mZ264e7lgPgFqkP47Ez+uvTluaIFbbw+x1sO0Elp1mTs2DWixiBhQJAGOXRefVG\n' +
  'oNvCw1frfrHIb1yc4owIHQIzuC4uYfT4BbQ4B7+xaRXe6KKpaKHiWHtN4+2iyAvk\n' +
  'KGjTAIlBxr72qQ=='

// 加密
export function encrypt(txt) {
  if (txt === '' || txt === undefined) {
    return txt
  }
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}

// 解密
export function decrypt(txt) {
  if (txt === '' || txt === undefined) {
    return txt
  }
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(privateKey) // 设置私钥
  return encryptor.decrypt(txt) // 对数据进行解密
}
